import React from "react";
import { useNavigate } from "react-router-dom";

import Card from "@mui/material/Card";
import CardActionArea from "@mui/material/CardActionArea";
import CardContent from "@mui/material/CardContent";
import CardMedia from "@mui/material/CardMedia";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";

import "./Courses.css";

const courses = [
  {
    img: (
      <img
        src="/images/pho-thong-tieu-chuan.png"
        alt="pho-thong-tieu-chuan"
        width={200}
      />
    ),
    courseName: "KHOÁ PHỔ THÔNG TIÊU CHUẨN",
    path: "/khoa-hoc/pho-thong-tieu-chuan",
  },
  {
    img: (
      <img src="/images/pho-thong-vip.png" alt="pho-thong-vip" width={200} />
    ),
    courseName: "KHOÁ PHỔ THÔNG VIP",
    path: "/khoa-hoc/pho-thong-vip",
  },
  {
    img: (
      <img
        src="/images/quoc-te-tieu-chuan.png"
        alt="quoc-te-tieu-chuan"
        width={200}
      />
    ),
    courseName: "KHOÁ QUỐC TẾ TIÊU CHUẨN",
    path: "/khoa-hoc/quoc-te-tieu-chuan",
  },
  {
    img: <img src="/images/quoc-te-vip.png" alt="quoc-te-vip" width={200} />,
    courseName: "KHOÁ QUỐC TẾ VIP",
    path: "/khoa-hoc/quoc-te-vip",
  },
  {
    img: <img src="/images/robotics-ai.png" alt="robotics-ai" width={200} />,
    courseName: "KHOÁ ROBOTICS & AI",
    path: "/khoa-hoc/robotics-ai",
  },
  {
    img: (
      <img
        src="/images/giao-tiep-giao-vien-nuoc-ngoai.png"
        alt="giao-tiep-giao-vien-nuoc-ngoai"
        width={200}
      />
    ),
    courseName: "KHOÁ GIAO TIẾP 1-1 VỚI GIÁO VIÊN NƯỚC NGOÀI",
    path: "/khoa-hoc/giao-tiep-giao-vien-nuoc-ngoai",
  },
  {
    img: <img src="/images/thuc-chien.png" alt="thuc-chien" width={200} />,
    courseName: "CÂU LẠC BỘ TIẾNG ANH THỰC CHIẾN",
    path: "/khoa-hoc/thuc-chien",
  },
];

function Courses() {
  const navigate = useNavigate();

  return (
    <Stack alignItems="center" spacing={2} width="100%">
      <Typography
        className="highlight"
        variant="h2"
        color="info.main"
        align="center"
        gutterBottom
      >
        Các khoá học
      </Typography>

      <Stack
        maxWidth={1000}
        direction="row"
        justifyContent="center"
        flexWrap="wrap"
      >
        {courses.map(({ img, courseName, path }) => (
          <Card
            key={courseName}
            elevation={0}
            sx={{ border: "none" }}
            onClick={() => navigate(path)}
          >
            <CardActionArea sx={{ width: 280, height: 280 }}>
              <CardMedia
                sx={{
                  height: 180,
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "flex-end",
                }}
              >
                {img}
              </CardMedia>
              <CardContent>
                <Typography
                  variant="h6"
                  color="info.main"
                  align="center"
                  gutterBottom
                >
                  {courseName}
                </Typography>
              </CardContent>
            </CardActionArea>
          </Card>
        ))}
      </Stack>
    </Stack>
  );
}

export default Courses;
